export class ChatFriendsError extends Error {
debugger
  constructor(message) {
    super(message);
    this.name = "ChatFriendsError";
    this.message = message;
  }
}
